import Tag from 'src/modules/shared/components/atoms/tag';
import { TestConversationIcon } from 'src/modules/shared/components/atoms/icons/custom-icons/test-conversation-icon';
import { Text } from 'src/modules/shared/components/atoms/text';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';
import type {
  ComponentAppearance,
  ComponentSize,
  ComponentVariant,
} from 'src/modules/shared/types/component.type';

interface TestConversationBadgeProps {
  appearance?: ComponentAppearance;
  className?: string;
  inlineContent?: boolean;
  size?: ComponentSize;
  variant?: ComponentVariant;
}

const inlineLabelSizeByBadgeSize: Record<ComponentSize, 'tiny' | 'small'> = {
  '2xs': 'tiny',
  xs: 'tiny',
  sm: 'small',
  md: 'small',
  lg: 'small',
};

export const TestConversationBadge = ({
  appearance = 'soft',
  className,
  inlineContent = false,
  size = 'xs',
  variant = 'warning',
}: TestConversationBadgeProps) => {
  const { t } = useI18n();

  const icon = (
    <TestConversationIcon
      appearance={appearance}
      inlineContent={inlineContent}
      size={size}
      variant={variant}
    />
  );

  return (
    <Tag
      content={
        inlineContent ? (
          <div className="flex items-center gap-1">
            {icon}
            <Text size={inlineLabelSizeByBadgeSize[size]}>
              {t('communications.testConversation.badge')}
            </Text>
          </div>
        ) : (
          t('communications.testConversation.badge')
        )
      }
      icon={inlineContent ? undefined : icon}
      size={size}
      variant={variant}
      appearance={appearance}
      className={className}
    />
  );
};
